import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'

if (document.querySelector('.flatpickr')) {
    const element = document.querySelector('.flatpickr')

    flatpickr.localize(Polish)
    flatpickr(element, {
        dateFormat: 'd/m/Y',
        positionElement: element,
        mode: 'range',
        showMonths: 2,
        minDate: 'today',
    })
}

if (document.querySelector('.flatpickr-single')) {
    const element = document.querySelector('.flatpickr-single')

    flatpickr.localize(Polish)
    flatpickr(element, {
        dateFormat: 'd.m.Y',
        positionElement: element,
        showMonths: 1,
        minDate: 'today',
    })
}
